import React from 'react';

export default function LegalConsentFields({
  acceptedLegal,
  errorText,
  onRevokeLegal,
  onOpenTerms,
  onOpenPrivacy,
}) {
  const openLegalDialog = (section = 'terms') => {
    if (section === 'privacy') {
      onOpenPrivacy();
      return;
    }
    onOpenTerms();
  };

  return (
    <div className="space-y-2 pt-1">
      <div className="flex items-start gap-3">
        <input
          type="checkbox"
          checked={acceptedLegal}
          onChange={(event) => {
            if (event.target.checked) {
              // Consent can only be granted via Accept in the legal dialog.
              openLegalDialog('terms');
              return;
            }
            onRevokeLegal();
          }}
          onClick={(event) => {
            if (!acceptedLegal) {
              event.preventDefault();
              openLegalDialog('terms');
            }
          }}
          className="mt-1 h-4 w-4 shrink-0 rounded border-gray-300 text-[#8b0000] focus:ring-[#8b0000] cursor-pointer"
          aria-invalid={Boolean(errorText)}
          aria-describedby={errorText ? 'legal-consent-error' : undefined}
        />
        <span className="text-[12px] leading-relaxed text-gray-800">
          I acknowledge that I have read and agree to the{' '}
          <button
            type="button"
            onClick={() => openLegalDialog('terms')}
            className="font-bold text-[#8b0000] hover:underline"
          >
            Terms of Use
          </button>{' '}
          and have read the{' '}
          <button
            type="button"
            onClick={() => openLegalDialog('privacy')}
            className="font-bold text-[#8b0000] hover:underline"
          >
            Privacy Policy
          </button>{' '}
          regarding the collection and processing of my personal information for account
          registration, ticketing, bookings, and related services.
        </span>
      </div>

      {errorText ? (
        <p id="legal-consent-error" className="text-[11px] font-semibold text-red-600">
          {errorText}
        </p>
      ) : null}
    </div>
  );
}
